import React, { FC } from 'react';

import { LazyImgix } from 'src/explore/elements/LazyImgix';

import styles from './index.module.sass';

interface ImageProps {
  desktop?: string;
  mobile?: string;
}

const Image: FC<ImageProps> = ({ desktop, mobile }) => (
  <>
    <LazyImgix
      className={styles.mobile}
      imgixParams={{ ar: '16:9' }}
      sizes="(min-width: 444px) 444px, 100vw"
      src={mobile ?? desktop}
    />

    <LazyImgix
      className={styles.desktop}
      imgixParams={{ ar: '1:1.6' }}
      sizes="444px"
      src={desktop ?? mobile}
    />
  </>
);

export default Image;
